const baseURL = "https://iacdc.tau.ac.il"

export async function fetchHomePage() {
  const response = await fetch(`${baseURL}/api/render-home`);

  if (!response.ok) {
    throw new Error("Failed to fetch homepage");
  }

  const result = await response.json();
  return result.data;
}

export async function fetchPageByPath(path) {
  const cleanPath = path.startsWith("/") ? path.slice(1) : path;
  const response = await fetch(`${baseURL}/api/render-page/${cleanPath}`);

  if (!response.ok) {
    throw new Error("Failed to fetch page");
  }

  const result = await response.json();
  return result.data;
}